import { DuplicateProcessRequestSchema, DuplicateProcessResponseSchema } from './duplicate-process.schema';
/**
 * Duplicate Process Endpoint Contract
 * Creates a snapshot copy of an existing process — step graph, event nodes,
 * open assignments, surveys, notes, and published layout — under a new name.
 *
 * The source process id is the `:id` path param; the body carries the new
 * process's name.
 */ export const duplicateProcessContract = {
    method: 'POST',
    path: '/api/v2/process/:id/duplicate',
    description: "Duplicate a process, copying the source's live state into a new process",
    requestSchema: DuplicateProcessRequestSchema,
    responseSchema: DuplicateProcessResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Invalid request body or validation error',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - insufficient permissions',
            404: 'Source process not found'
        }
    }
};

//# sourceMappingURL=duplicate-process.contract.js.map